import React, { Component } from "react";
import Heading from "../Heading.jsx";
import SingleInput from "./SingleInput";

class ContactSec extends Component {
  state = {
    Name: "",
    Email: "",
    Subject: "",
    Message: "",
  };

  changeHandler = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  submit = (event) => {
    event.preventDefault();
    console.log(this.state);
    this.setState(
      {
        Name: "",
        Email: "",
        Subject: "",
        Message: "",
      },
      () => {
        alert("Check Your Console. xD");
      }
    );
  };

  render() {
    return (
      <div>
        <div id="contact" style={{ background: "#111a28" }}>
          <div className="container">
            <form onSubmit={this.submit}>
              <div className="row">
                <div className="col-12 text-center">
                  <Heading heading={this.props.heading} />
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-6">
                  <SingleInput
                    className="form-control text-white bg-transparent w-100"
                    type="text"
                    name="Name"
                    placeholder="নাম"
                    value={this.state.Name}
                    onChange={this.changeHandler}
                  />
                  <SingleInput
                    className="form-control text-white bg-transparent w-100 mt-4"
                    type="email"
                    name="Email"
                    placeholder="ই-মেইল"
                    value={this.state.Email}
                    onChange={this.changeHandler}
                  />
                  <SingleInput
                    className="form-control text-white bg-transparent w-100 mt-4"
                    type="text"
                    name="Subject"
                    placeholder="বিষয়"
                    value={this.state.Subject}
                    onChange={this.changeHandler}
                  />
                </div>
                <div className="col-md-6">
                  <textarea
                    className="form-control text-white bg-transparent w-100 mt-4 mt-md-0 h-100"
                    name="Message"
                    placeholder="বার্তা লিখুন"
                    value={this.state.Message}
                    onChange={this.changeHandler}
                  ></textarea>
                </div>
                <div className="col-12 mt-5">
                  <button className="w-100 border-0">বার্তা পাঠান</button>
                </div>
              </div>
            </form>
          </div>
          <div className="space"></div>
        </div>
      </div>
    );
  }
}

export default ContactSec;
